// noinspection JSUnusedGlobalSymbols

export { default as TextstringProvider } from './components/textstring-provider/TextstringProvider';
export { default as Textstring } from './components/textstring/Textstring';
export type { ITextstring, TextstringReplacement } from './components/textstring/types';
export { useTextstringValue } from './hooks/useTextstringValue';
export { getTextstringValue, initTextstrings, ttsToITextString } from './utils/textstring';
